import React from 'react';
import { useNavigate } from 'react-router-dom';
import { motion } from 'framer-motion';
import { ArrowRight } from 'lucide-react';
import { Season } from '../types';

interface SeasonCardProps {
  season: Season;
  title: string;
  description: string;
  movieCount?: number;
  onClick?: () => void;
}

const SeasonCard: React.FC<SeasonCardProps> = ({ season, title, description, movieCount, onClick }) => {
  const navigate = useNavigate();
  
  const seasonConfig = {
    winter: {
      gradient: 'from-blue-50 to-indigo-50',
      border: 'border-blue-200',
      icon: '❄️',
    },
    spring: {
      gradient: 'from-pink-50 to-rose-50',
      border: 'border-pink-200',
      icon: '🌸',
    },
    summer: {
      gradient: 'from-yellow-50 to-orange-50',
      border: 'border-yellow-200',
      icon: '☀️',
    },
    autumn: {
      gradient: 'from-orange-50 to-red-50',
      border: 'border-orange-200',
      icon: '🍂',
    },
  };
  const config = seasonConfig[season];

  const handleClick = () => {
    if (onClick) {
      onClick();
    } else {
      navigate(`/movies?season=${season}`);
    }
  };

  return (
    <motion.div
      whileHover={{ scale: 1.05 }}
      whileTap={{ scale: 0.95 }}
      onClick={handleClick}
      className={`relative overflow-hidden rounded-2xl p-6 cursor-pointer shadow-lg bg-gradient-to-br ${config.gradient} border ${config.border}`}
    >
      <div className="relative z-10">
        <div className="flex items-center justify-between mb-4">
          <span className="text-4xl">{config.icon}</span>
          <div className="text-sm font-medium bg-white/80 text-gray-600 px-3 py-1 rounded-full shadow-sm">
            {movieCount ? `${movieCount} movies` : 'Explore'}
          </div>
        </div>
        
        <h3 className="text-2xl font-bold text-gray-800 mb-2">{title}</h3>
        <p className="text-gray-600 mb-6">{description}</p>
        
        <div className="flex items-center text-romcom-red font-medium">
          <span>Explore Collection</span>
          <ArrowRight className="w-4 h-4 ml-2" />
        </div>
      </div>
    </motion.div>
  );
};

export default SeasonCard;